import DetailRow from './DetailRow';
import { CategoryDetail, LabelDetail } from './LabelDetail';

export default DetailRow;
export { CategoryDetail, LabelDetail };
